/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment } from 'react';
// import { useAPI } from 'components/lib';

export function Statistics(props){

  // const user = useAPI('/api/user');

  return (
    <Fragment>

      {/* <Message 
        title='Need Help?'
        type='info'
        text="Contact our support team below. You can also enable or disable permission for our support team to access your account to help resolve any issues."
      /> */}

      
    </Fragment>
  )
}